import clsx from 'clsx'
import { Button } from 'gu-ui-kit'
import omit from 'lodash/omit'
import formStyles from 'modules/Forms/common-form.module.scss'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import styles from 'modules/Forms/Account/Create/account-form-creation.module.scss'
import { PATCH_ACCOUNT_ADVERTISER_INFO } from 'modules/Services/types'
import AdvertiserInfoGroup from 'modules/Forms/Account/Create/subcomponents/AdvertiserInfoGroup'

let AdvertiserInfoEditForm = ({
  handleSubmit,
  submitting,
  onClose = () => {},
  form,
  networkType = '',
  accountId,
  initialValues,
}) => {
  const { t } = useTranslation()
  const selector = formValueSelector(form)

  const { advertiser_info } = useSelector((state) => ({
    advertiser_info: selector(state, 'advertiser_info'),
  }))

  const submit = useCallback(
    (values, dispatch) =>
      new Promise((resolve, reject) => {
        dispatch({
          meta: { resolve, reject },
          type: PATCH_ACCOUNT_ADVERTISER_INFO,
          payload: {
            accountId: accountId,
            data: omit(values.advertiser_info, ['status', 'id']),
            formName: form,
          },
        })
      }).then(() => {
        onClose()
      }),
    [],
  )

  return (
    <>
      <form onSubmit={handleSubmit(submit)}>
        <AdvertiserInfoGroup
          form={form}
          advertiser_info={advertiser_info}
          networkType={networkType}
          initialValues={initialValues}
          autoSave={false}
          defaultFillingType={'manually'}
        />

        <div className={clsx(formStyles['formControl__action-buttons'], styles['action-buttons'])}>
          <Button
            disabled={submitting}
            onClick={onClose}
            variant={'ghost'}
            grey
            size="l"
            type="button"
          >
            {t('common::buttons.cancel')}
          </Button>
          <Button
            disabled={submitting}
            size="l"
            variant="primary"
            type="submit"
            bgColor={'Label-GU-Primary'}
          >
            {t('services::forms.advertiser_info.save')}
          </Button>
        </div>
      </form>
    </>
  )
}

AdvertiserInfoEditForm = reduxForm({
  form: 'AdvertiserInfoEditForm',
  // enableReinitialize: true,
  shouldAsyncValidate: shouldAsyncValidate,
  // touchOnChange: true,
})(AdvertiserInfoEditForm)

AdvertiserInfoEditForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  blur: PropTypes.func,
  focus: PropTypes.func,
  change: PropTypes.func,
  valid: PropTypes.bool,
  onClose: PropTypes.func,
  touch: PropTypes.func,
  form: PropTypes.string,
  accountLogin: PropTypes.string,
  accountId: PropTypes.string,
  i18n: PropTypes.string,
  pristine: PropTypes.bool,
  networkType: PropTypes.string,
  networkId: PropTypes.string,
  advertiser_info_errors: PropTypes.array,
  initialValues: PropTypes.object,
}

export default AdvertiserInfoEditForm
